import React from 'react';
import DateSales from './dateSales'
import LastSales from './lastSales'

class Component extends React.Component {

  componentWillMount() {
    if (this.props.initial && this.props.user.role_id > 0) {
      this.props.api("affiliate/subaffiliates")  
    }    
  }

  render() {
    return (
      <div>            
        <div class="row">
          <div class="col-md-8"><DateSales subaffiliates={this.props.subaffiliates} /></div>                
          <div class="col-md-4"><LastSales /></div>
        </div>
      </div>
    );
  }
}

import api from '../../actions/api'
import setState from '../../actions/state'
import { connect } from 'react-redux'

export default connect(function (state) {
  let apiState = state.api["affiliate_subaffiliates"] || state.api.initial;
  return {
    initial: apiState.initial,
    subaffiliates: apiState.items || [],
    apiState: apiState,
    state: state.state["affiliate_subaffiliates"] || state.state.initial,
    user: state.session.user
  }
}, {api, setState: setState("affiliate_subaffiliates")})(Component)  